/* import __COLOCATED_TEMPLATE__ from './conversation-rating-leads.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();